<template>
 <div class="">
    <masternav/>
    <br>
    <fleetview/>
    <hr>
    <contactcomp/>
    <br>
    <mainfooter/>
 </div> 
</template>

<script>
// @ is an alias to /src
import masternav           from '@/components/masternav.vue'
import maincontent         from '@/components/maincontent.vue'
import mainfooter          from '@/components/mainfooter.vue'
import rents               from '@/components/rents.vue'
import footsecondary       from '@/components/footsecondary.vue'
import contactcomp         from '@/components/contactcomp.vue'
import reservestep1and2    from '@/components/reservestep1and2.vue'
import fleetview           from '@/components/fleetview.vue'

export default {
  name: 'Fleet',
  metaInfo: {
      title: "Enterprise Panama - Flota | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
  components: {
    masternav,
    mainfooter,
    maincontent,
    rents,
    footsecondary,
    contactcomp,
    reservestep1and2,
    fleetview
  }
}
</script>




